import {
  Breadcrumb,
  Button,
  Card,
  IconDownload,
  IconUpload,
  Stepper,
} from "tvs-unified-lib";
import { Flex, Root, StepDescription, StepTitle, Title } from "./styles";
import { Fragment, useState } from "react";
import Step1 from "./Step1";
import { stepContent } from "./constant";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { Link, useNavigate } from "react-router-dom";
import Step4 from "./Step4";
import { uploadApi } from "@/services";
import { useSnackbar } from "notistack";

export const NewUpload = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [step, setStep] = useState<number>(1);
  const [file, setFile] = useState({
    fileUploadedUrl: "",
    fileName: "",
  });
  const [fileId, setFileId] = useState<number>();
  const [selected, setSelected] = useState<string[]>([]);
  const [errorSummaryFileUrl, setErrorSummaryFileUrl] = useState<string>("");

  const handleCancel = () => {
    navigate("/upload");
  };

  const downFileErrorSummary = async () => {
    if (!fileId || !errorSummaryFileUrl) return;
    await uploadApi
      .fileError(fileId)
      .then(({ data: urlErrorFile }) => {
        if (urlErrorFile) {
          const link = document.createElement("a");
          link.href = urlErrorFile;
          link.setAttribute("download", errorSummaryFileUrl);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((err) => {
        enqueueSnackbar(err, {
          variant: "error",
        });
      });
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1 setStep={setStep} handleCancel={handleCancel} />;
      case 2:
        return (
          <Step2
            setFile={setFile}
            setStep={setStep}
            handleCancel={handleCancel}
            setSelected={setSelected}
          />
        );
      case 3:
        return (
          <Step3
            setFileId={setFileId}
            setStep={setStep}
            file={file}
            handleCancel={handleCancel}
            selected={selected}
            setSelected={setSelected}
          />
        );
      case 4:
        return (
          <Step4
            fileId={fileId}
            setStep={setStep}
            handleCancel={handleCancel}
            mandatoryFields={selected}
            setErrorSummaryFileUrl={setErrorSummaryFileUrl}
          />
        );
      default:
        return <Step1 setStep={setStep} handleCancel={handleCancel} />;
    }
  };

  const renderDownload = () => {
    switch (step) {
      case 1:
        return (
          <Flex>
            <Link to="/Campaign-Template.xlsx" target="_blank" download>
              <Button
                label="Campaign Template"
                variant="no-border"
                iconPosition="left"
                icon={<IconDownload fill="#3548C9" />}
              />
            </Link>
          </Flex>
        );
      case 2:
        return (
          <Flex>
            <Link to="/Campaign-Template.xlsx" target="_blank" download>
              <Button
                label="Campaign Template"
                variant="no-border"
                iconPosition="left"
                icon={<IconDownload fill="#3548C9" />}
              />
            </Link>
          </Flex>
        );
      case 3:
        return null;
      case 4:
        return (
          <Flex>
            <Button
              label="Re-upload File"
              variant="outline"
              iconPosition="left"
              icon={<IconUpload fill="#3548C9" />}
              onClick={() => {
                setStep(2);
              }}
            />
            {errorSummaryFileUrl && (
              <Button
                disabled={!errorSummaryFileUrl}
                label="Download File"
                variant="no-border"
                iconPosition="left"
                icon={<IconDownload fill="#3548C9" />}
                onClick={downFileErrorSummary}
              />
            )}
          </Flex>
        );
      default:
        return null;
    }
  };

  return (
    <Root>
      <Breadcrumb
        items={[
          {
            content: <a href="/upload">Upload</a>,
            isActive: false,
          },
          {
            content: <a>New Upload</a>,
            isActive: true,
          },
        ]}
      />
      <Title>New Upload</Title>
      <Card heading="How to Upload Accounts in Bulk" className="card-filter">
        <Stepper
          current={step}
          steps={["", "", "", ""]}
          onChangeStep={() => {}}
          completedSteps={step === 4 ? [4] : []}
        />
        <Fragment>
          <StepTitle>{stepContent[step].title}</StepTitle>
          <StepDescription
            dangerouslySetInnerHTML={{
              __html: stepContent[step].description,
            }}
          />
          {renderDownload()}
        </Fragment>
      </Card>
      {renderStep()}
    </Root>
  );
};

export default NewUpload;
